import React from "react";
import { Col, Row } from "antd";
import "./Copyright.css";

export interface CopyrightProps {}

const Copyright = (props: CopyrightProps) => {
  const getClassName = () => {
    let page = window.location.pathname.split("/");
    if (page[1] === "login" || page[1] === "signup") return "copyright-text-white";
    if (page[1] === "" || page.length === 5) return "copyright-text-home-page";
    return "copyright-text-blue";
  };

  return (
    <Row className={getClassName()}>
      <Col span={24}>
        <Row justify="center">Copyright © 2023 Metals Trading</Row>
      </Col>
    </Row>
  );
};

export default Copyright;
